import { render } from "./MentorRegistration.vue?vue&type=template&id=3276ebf3"
import script from "./MentorRegistration.vue?vue&type=script&lang=js"
export * from "./MentorRegistration.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jj_mac/Documents/find-a-mentor-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__